const FormFileInputDropTargetHook = {
  mounted() {
    const el = this.el;
    let counter = 0;

    el.addEventListener('dragenter', function (e) {
      e.preventDefault();
      counter++;
      el.classList.add('phx-dragover');
    });

    el.addEventListener('dragleave', function (e) {
      e.preventDefault();
      counter--;
      if (counter === 0) {
        el.classList.remove('phx-dragover');
      }
    });
  },
};

export default FormFileInputDropTargetHook;
